<template>
    <div class="calendar-popup-wrapper">
        <div class="calendar-popup">
            <div class="calendar-popup__blok-1">
              <svg width="113" height="103" viewBox="0 0 113 103" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M92.5806 102.225H15.8065C7.07621 102.225 0 95.1491 0 86.4188C0 77.6886 7.07621 70.6124 15.8065 70.6124C15.8065 57.0894 28.7886 47.3506 41.7516 51.0773C56.545 30.7739 88.3688 37.3011 94.0653 61.6337C104.596 62.393 112.903 71.1797 112.903 81.9027C112.903 93.1253 103.803 102.225 92.5806 102.225Z" fill="#C4E1E8"/>
                <path d="M88.375 49.9767C75.3688 39.525 56.1682 42.006 46.2677 55.5937C33.2771 51.8591 20.3226 61.63 20.3226 75.1287C7.60375 75.1287 0.305968 89.3051 7.11883 99.6231C2.82823 96.7977 0 91.94 0 86.4191C0 77.6888 7.07621 70.6126 15.8065 70.6126C15.8065 57.0896 28.7886 47.3509 41.7516 51.0775C53.1452 35.4402 76.2529 34.8971 88.375 49.9767Z" fill="#A4D5DD"/>
                <path d="M11.2903 95.4517C12.5374 95.4517 13.5484 94.4407 13.5484 93.1936C13.5484 91.9465 12.5374 90.9355 11.2903 90.9355C10.0432 90.9355 9.03223 91.9465 9.03223 93.1936C9.03223 94.4407 10.0432 95.4517 11.2903 95.4517Z" fill="#A4D5DD"/>
                <path d="M7.90296 90.9348C8.52651 90.9348 9.03199 90.4293 9.03199 89.8058C9.03199 89.1822 8.52651 88.6768 7.90296 88.6768C7.27941 88.6768 6.77393 89.1822 6.77393 89.8058C6.77393 90.4293 7.27941 90.9348 7.90296 90.9348Z" fill="#A4D5DD"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M92 74.766C91.8934 74.767 91.7866 74.7674 91.6798 74.7674C72.5299 74.7674 57.0058 59.2176 57.0058 40.0359C57.0058 32.5738 59.3553 25.6612 63.3537 20C44.3513 20.1722 29 35.6554 29 54.73C29 73.9117 44.524 89.4615 63.6739 89.4615C75.3739 89.4615 85.7205 83.657 92 74.766Z" fill="#FFDF81"/>
                <path d="M39.4735 63.2514C37.4589 63.2514 35.8258 61.6183 35.8258 59.6037C35.8258 57.5892 37.4589 55.9561 39.4735 55.9561C41.488 55.9561 43.1211 57.5892 43.1211 59.6037C43.1211 61.6183 41.488 63.2514 39.4735 63.2514Z" fill="#FFCD76"/>
                <path d="M44.9452 55.9553C43.9379 55.9553 43.1214 55.1387 43.1214 54.1314C43.1214 53.1242 43.9379 52.3076 44.9452 52.3076C45.9525 52.3076 46.769 53.1242 46.769 54.1314C46.769 55.1387 45.9525 55.9553 44.9452 55.9553Z" fill="#FFCD76"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M86.3462 76.5385C68.057 76.5385 53.2308 61.7122 53.2308 43.4231C53.2308 34.2782 56.9376 25.9991 62.9306 20.0064C63.0714 20.0034 63.2124 20.0013 63.3537 20C59.3553 25.6612 57.0058 32.5738 57.0058 40.0359C57.0058 59.2176 72.5299 74.7674 91.6798 74.7674C91.7866 74.7674 91.8934 74.767 92 74.766C91.6492 75.2626 91.2858 75.7496 90.9101 76.2265C89.4182 76.4322 87.8946 76.5385 86.3462 76.5385Z" fill="#FFCD76"/>
                <path d="M71.8026 2.1465C72.0221 1.47087 72.9779 1.47088 73.1974 2.1465L73.5702 3.29369C73.6684 3.59584 73.9499 3.80041 74.2676 3.80041H75.4738C76.1842 3.80041 76.4796 4.70946 75.9049 5.12702L74.929 5.83602C74.672 6.02276 74.5645 6.35376 74.6626 6.65591L75.0354 7.80309C75.2549 8.47872 74.4816 9.04054 73.9069 8.62298L72.931 7.91398C72.674 7.72724 72.326 7.72724 72.069 7.91398L71.0931 8.62298C70.5184 9.04054 69.7451 8.47872 69.9646 7.80309L70.3374 6.65591C70.4355 6.35376 70.328 6.02276 70.071 5.83602L69.0951 5.12702C68.5204 4.70946 68.8158 3.80041 69.5262 3.80041H70.7324C71.0501 3.80041 71.3316 3.59584 71.4298 3.29369L71.8026 2.1465Z" fill="#70C5FA"/>
                <path d="M11.9149 30.8784C12.4138 29.3429 14.5862 29.3429 15.0851 30.8784L15.9322 33.4856C16.1554 34.1724 16.7953 34.6373 17.5173 34.6373H20.2587C21.8733 34.6373 22.5446 36.7033 21.2384 37.6523L19.0205 39.2637C18.4364 39.6881 18.192 40.4404 18.4151 41.1271L19.2622 43.7343C19.7611 45.2698 18.0037 46.5467 16.6975 45.5977L14.4796 43.9863C13.8955 43.5619 13.1045 43.5619 12.5204 43.9863L10.3025 45.5977C8.99632 46.5467 7.23886 45.2698 7.73778 43.7343L8.58492 41.1271C8.80804 40.4404 8.56361 39.6881 7.97947 39.2637L5.76162 37.6523C4.45543 36.7033 5.12673 34.6373 6.74127 34.6373H9.48267C10.2047 34.6373 10.8446 34.1724 11.0678 33.4856L11.9149 30.8784Z" fill="#70C5FA"/>
                <path d="M96.2953 36.7076C96.6745 35.5406 98.3255 35.5406 98.7047 36.7076L99.3485 38.6891C99.5181 39.211 100.004 39.5643 100.553 39.5643H102.637C103.864 39.5643 104.374 41.1345 103.381 41.8558L101.696 43.0804C101.252 43.4029 101.066 43.9747 101.235 44.4966L101.879 46.4781C102.258 47.6451 100.923 48.6155 99.9301 47.8942L98.2445 46.6696C97.8006 46.3471 97.1994 46.3471 96.7555 46.6696L95.0699 47.8942C94.0772 48.6155 92.7415 47.6451 93.1207 46.4781L93.7645 44.4966C93.9341 43.9747 93.7483 43.4029 93.3044 43.0804L91.6188 41.8558C90.6261 41.1345 91.1363 39.5643 92.3634 39.5643H94.4468C94.9956 39.5643 95.4819 39.211 95.6515 38.6891L96.2953 36.7076Z" fill="#70C5FA"/>
              </svg>

                <div class="calendar-popup__text">
                    Чтобы ничто не омрачило ваш праздник, убедитесь, что погода будет хорошей.
                </div>
            </div>
            <div class="calendar-popup__blok-2">
                <div class="calendar-popup__text-2">
                    Ознакомьтесь с 
                    <span @click="clickTerms()">
                        условиями возврата
                    </span>
                </div>
                <div class="calendar-popup__button"
                    @click="clickPopupButton()"
                >
                    OK
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            async clickPopupButton() {
                this.$emit('clickPopupButton')
            },
            async clickTerms() {
                this.$router.push('/return-policy')
            }
        }
    }
</script>

<style lang="less">

    .calendar-popup-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 11;
        position: absolute;
        min-height: 430px;
        left: 0px;
        top: 0px;
    }

    .calendar-popup {
        width: 343px;
        border-radius: 13px;
        overflow: hidden;
    }

    .calendar-popup__blok-1 {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        background-color: #41355D;
    }

    .calendar-popup__blok-1 svg {
        margin-top: 23px;
        margin-bottom: 11px;
    }

    .calendar-popup__text,
    .calendar-popup__text-2 {
        font-size: 15px;
        font-family: 'Roboto-Light';
        line-height: 20px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 16px;
    }

    .calendar-popup__blok-2 {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: #343050;
        width: 100%;
    }

    .calendar-popup__text-2 span {
        border-bottom: 2px dashed #FFFFFF;
        height: 23px;
        margin-left: 6px;
        cursor: pointer;
    }

    .calendar-popup__text-2 {
        margin-bottom: 17px;
        margin-top: 16px;
        display: flex;
    }

    .calendar-popup__button {
        width: 303px;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
        font-size: 16px;
        color: #272A2F;
        line-height: 12px;
        font-family: 'Montserrat-Medium';
        margin-bottom: 20px;
        border-radius: 5px;
        cursor: pointer;
    }
</style>